import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Eye, Mail, MessageSquare } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function ChristmasPalace() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-201" data-mp="1d0ou1her34b3">
      <div className="max-w-6xl mx-auto px-4" data-id="element-202" data-mp="1d1zzrmrram4u">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-203" data-mp="1h1h247bvz35s">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-204" data-mp="1r06oodeq9bsd" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-205" data-mp="1vy85erookz0o">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-206" data-mp="1vx6s0gk700fs">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-207" data-mp="3st4lekbmkoil">
              E-Commerce Growth
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-208" data-mp="318qnf4hckhq1">
              Multi-Channel Scaling
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-209" data-mp="2ri5rjot25rat">
              Email + SMS Monetization
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-210" data-mp="3k5rvwza40zyq">
            The Christmas Palace
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-211" data-mp="3a7kpvbhd02bi">
            Turning Content into Holiday Demand at Scale
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-212" data-mp="1yt74qedzq0z6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-213" data-mp="1yu9wspn1u9go">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-214" data-mp="1uqajsh0z9ss2">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-215" data-mp="217c21t1lvcp8">
                <Eye className="w-24 h-24 text-engage-yellow" data-id="element-216" data-mp="1maur32xbw037" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-217" data-mp="1r9frp3ghsls6">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-218" data-mp="1rb90opekvi3c">
                  <Eye className="w-6 h-6 text-engage-yellow" data-id="element-219" data-mp="1i8zrq3yyjws2" />
                </div>
                <div data-id="element-220" data-mp="13k3n6gw411w7">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-221" data-mp="13kwkkr96if1o">
                    8M+ Views
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-222" data-mp="uj5gfquaeg9x">
                    Organic reach generated
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-223" data-mp="fvye29ivaqmn">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-224" data-mp="azq4dbnfvpmv">
                <Mail className="w-24 h-24 text-engage-yellow" data-id="element-225" data-mp="jy1u7bgheje9" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-226" data-mp="k0egu1x6phxn">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-227" data-mp="ythmpc1ey78j">
                  <Mail className="w-6 h-6 text-engage-yellow" data-id="element-228" data-mp="17ne98ryhploh" />
                </div>
                <div data-id="element-229" data-mp="13m112b7xd6ee">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-230" data-mp="13lj0j2e8c60o">
                    +102%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-231" data-mp="1hjpp1rxagtno">
                    Email Revenue Growth
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-232" data-mp="20qfb4yz07hz2">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-233" data-mp="25hxaxjpajcig">
                <MessageSquare className="w-24 h-24 text-engage-yellow" data-id="element-234" data-mp="2ai2xilgpe8to" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-235" data-mp="1ds2dt0v6yij8">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-236" data-mp="1hs2yh38vvpyq">
                  <MessageSquare className="w-6 h-6 text-engage-yellow" data-id="element-237" data-mp="1rpqxw6hfpln8" />
                </div>
                <div data-id="element-238" data-mp="2y5t8srqljagt">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-239" data-mp="2y6cffcasqcfj">
                    +1,919%
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-240" data-mp="3370f0md3c1ld">
                    SMS Growth
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-241" data-mp="hq6bsgrmhgj5">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-242" data-mp="ctfwhvnn6oys">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-243" data-mp="8rm1o404of6j">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-244" data-mp="3r6p3eno7bpm" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-245" data-mp="3uxhiqpqcpa6x">
              The Christmas Palace had a powerful in-store experience, but its
              digital presence didn{'\u2019'}t reflect that same level of
              impact. During peak season{'\u2014'}when attention is everything
              {'\u2014'}the brand lacked a content system capable of capturing
              demand at scale and translating it into store visits. With a short
              revenue window and fast-moving platforms, every piece of content
              needed to perform quickly or risk losing momentum.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-246" data-mp="3dof5khny20o6">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-247" data-mp="3dmlyj19f5efn">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-248" data-mp="a8ro4427pdz8" />
              <div className="relative z-10" data-id="element-249" data-mp="3sdl5k7ulvux4">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-250" data-mp="9sgmot6nodt">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-251" data-mp="2gxwf36i58drk" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-252" data-mp="2l0jcdmxl2qw5">
                  We built a content-first growth engine designed for speed,
                  volume, and emotional impact. By producing platform-native
                  short-form videos and leveraging a high-volume testing
                  strategy, we allowed performance to dictate scale. Each piece
                  of content was crafted to capture attention instantly while
                  reinforcing the immersive, emotional experience of the brand
                  {'\u2014'}creating a loop where content drove traffic, and
                  in-store moments fueled more content.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-253" data-mp="24i6lgu5k6kup">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-254" data-mp="1bzsv1fmjy15n" />
              <div className="relative z-10" data-id="element-255" data-mp="16zwtdn1bult9">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-256" data-mp="lhd3qmperbmu">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-257" data-mp="qhizadystia7" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-258" data-mp="vf1ayc47ablw">
                  In just 90 days, the brand became highly visible across social
                  platforms, generating over 8 million views and positioning
                  itself as a must-visit holiday destination. Content translated
                  directly into increased foot traffic and stronger sales
                  momentum, turning organic reach into real-world demand. What
                  started as a visibility effort became a scalable engine
                  driving both attention and revenue during the most critical
                  season.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-259" data-mp="1s3qsu2ftv47v">
            <div className="flex justify-center mb-8" data-id="element-260" data-mp="37o9ln5gbtg7h">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-261" data-mp="37qvr8zjnpln2">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-262" data-mp="3vdakq239rf03" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-263" data-mp="e6i7ixhaik63">
              We didn{'\u2019'}t just create content{'\u2014'}we created demand.
              The store became something people wanted to experience before even
              arriving.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-264" data-mp="2smexdjejnscv">
              <img src="https://cdn.magicpatterns.com/uploads/2rZSGAWtGvFRDAikqTV9Zd/The_Christmas_Palace-CS.png" alt="The Christmas Palace" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-265" data-mp="2sohwcsxocvtq" />
              <div className="font-bold text-engage-white text-lg" data-id="element-266" data-mp="3ge2exapx1r2h">
                The Christmas Palace Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-267" data-mp="3pceew3coa17l">
                Leadership, The Christmas Palace
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-268" data-mp="7v0h52u8l5cn">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-269" data-mp="cqz88y6y91gr" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-270" data-mp="2um7jgczlnci">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-271" data-mp="2t2r9prbzcaq">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-272" data-mp="3q03qizr8k3iv">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-273" data-mp="3g991xoqioru9">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}